import { render, staticRenderFns } from "./RequestedProjectRejectionNotificationComponent.vue?vue&type=template&id=5d42ddd8&"
import script from "./RequestedProjectRejectionNotificationComponent.vue?vue&type=script&lang=ts&"
export * from "./RequestedProjectRejectionNotificationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports